import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import HomeTopCard from "../../../components/HomeComponents/HomeTopCard";
import "../userDashboard.css";
import BookSummaryComp from "../../../components/BookComponents/BookSummaryComp";
import MiniAudioPlayer from "../../../components/sharedcomponents/AudioPlayerSmallComp";

export const UserBooksDetailsPage = () => {

  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar showBackButton displayType="logo" showNotification showProfileBtn></TopBar>
        <BookSummaryComp></BookSummaryComp>
      </div>
    </>
  );
};

export default UserBooksDetailsPage;
